<template>
  <section>
    <router-link
      :to="{name: 'ShelterStatus'}">
      Back
    </router-link>
    <h3>Add Shelter Status</h3>
    <div class="card">
      Shelter: <strong>{{shelter.code}} -- {{shelter.name}}</strong>
       @ {{shelter.location}}
    </div>
    <b-field label="Occupancy">
      <b-select placeholder="Select occupancy status" v-model="form.occupancyStatus">
        <option value="EMPTY">
          Empty
        </option>
        <option value="HALF FULL">
          Half Full
        </option>
        <option value="FULL">
          Full
        </option>
      </b-select>
    </b-field>
    <b-field label="Report Time">
      <b-datetimepicker
          v-model="form.time"
          rounded
          placeholder="Click to select..."
          icon="calendar-today">
      </b-datetimepicker>
    </b-field>
    <b-field label="Opening/Closing Time">
      <b-datetimepicker
          v-model="form.openCloseTime"
          rounded
          placeholder="Click to select..."
          icon="calendar-today">
      </b-datetimepicker>
    </b-field>
    <b-field label="Max Occupancy">
      <b-input v-model="form.maxOccupancy" placeholder="0" type="number"/>
    </b-field>
    <b-field label="Number of Refugees">
      <b-input v-model="form.numOfRefugees" placeholder="0" type="number"/>
    </b-field>
    <b-field label="Voluntary Evacuation">
      <b-input v-model="form.numOfRefugeesVoluntary" placeholder="0" type="number"/>
    </b-field>
    <b-field label="Number of Displaced Household">
      <b-input v-model="form.numOfDisplacedHouseHold" placeholder="0" type="number"/>
    </b-field>
    <b-field label="Number of Displaced Household Voluntary">
      <b-input v-model="form.numOfDisplacedHouseHoldVoluntary" placeholder="0" type="number"/>
    </b-field>
    <h4>Lifeline Status</h4>
    <b-field label="Electricity">
      <b-select placeholder="Select occupancy status" v-model="form.lifeline.electricity">
        <option value="AVAILABLE">
          Available
        </option>
        <option value="NOT_AVAILABLE">
          Not Available
        </option>
      </b-select>
    </b-field>
    <b-field label="Waterway">
      <b-select placeholder="Select occupancy status" v-model="form.lifeline.waterway">
        <option value="AVAILABLE">
          Available
        </option>
        <option value="NOT_AVAILABLE">
          Not Available
        </option>
      </b-select>
    </b-field>
    <b-field label="Gas">
      <b-select placeholder="Select occupancy status" v-model="form.lifeline.gas">
        <option value="AVAILABLE">
          Available
        </option>
        <option value="NOT_AVAILABLE">
          Not Available
        </option>
      </b-select>
    </b-field>
    <b-field label="Phone">
      <b-select placeholder="Select occupancy status" v-model="form.lifeline.phone">
        <option value="AVAILABLE">
          Available
        </option>
        <option value="NOT_AVAILABLE">
          Not Available
        </option>
      </b-select>
    </b-field>
    <b-button
      @click="submit">
      Save
    </b-button>
  </section>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'CreateDisasterName',
  data () {
    return {
      form: {
        occupancyStatus: '',
        time: 0,
        openCloseTime: '',
        maxOccupancy: 0,
        numOfRefugees: 0,
        numOfRefugeesVoluntary: 0,
        numOfDisplacedHousehold: 0,
        numOfDisplacedHouseholdVoluntary: 0,
        lifeline: {
          electricity: '',
          waterway: '',
          gas: '',
          phone: ''
        }
      }
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapGetters('Shelter', ['shelter']),
    shelterId () {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapActions('Shelter',['fetchOne']),
    ...mapActions('ShelterStatus',['create']),
    submit () {
      const data = {...this.form, shelterCode: this.shelterId}
      this.create(data)
        .then(() => {
          this.$router.replace({name: 'ShelterStatus'})
        })
        .catch(() => {
          alert('Create failed')
        })
    },
    init () {
      this.fetchOne({code: this.shelterId})
    }
  }
}
</script>
